(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  function addImageCaptions() {
    document.querySelectorAll('.article-body img, .article-body video').forEach((media) => {
      if (media.closest('figure.featured-image') || media.closest('.grid-images')) {
        return;
      }
      const figure = document.createElement('figure');
      const caption = document.createElement('figcaption');

      media.parentNode.insertBefore(figure, media);
      figure.appendChild(media);

      if (media.alt !== '') {
        caption.textContent = media.alt;
        figure.appendChild(caption);
      }
    });
  }
  document.addEventListener('DOMContentLoaded', addImageCaptions);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  function productGalleryLightbox() {
    Fancybox.bind("[data-fancybox='gallery']", {
      closeButton: true,
      zoomEffect: false,
      Carousel: {
        Thumbs: false,
        Toolbar: {
          display: {
            left: [],
            middle: [],
            right: [],
          },
        },
        Arrows: {
          prevTpl: 'Previous',
          nextTpl: 'Next',
        },
        Zoomable: {
          tpl: (slide) => {
            if (!slide.srcsetMobile && !slide.srcsetDesktop) return null;
            let html = '<picture class="f-panzoom__content">';
            if (slide.srcsetMobile) {
              html += `<source media="(max-width: 799px)" srcset="${slide.srcsetMobile}" sizes="100vw" />`;
            }
            if (slide.srcsetDesktop) {
              html += `<source media="(min-width: 800px)" srcset="${slide.srcsetDesktop}" sizes="100vw" />`;
            }
            html += `<img src="${slide.src}" alt="${slide.caption || ''}" />`;
            html += '</picture>';
            return html;
          },
        },
        infinite: false,
      },
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    productGalleryLightbox();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-row"] && !Shopify.designMode) return;
  try {
    
  var reccLogs = false;

  function related() {
    const relatedSection = document.querySelector('section.row--recommendations');

    if (!relatedSection) return;

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(relatedSection);

      const url = relatedSection.dataset.url;

      if (reccLogs) console.log('Fetching recommendations from: ', url);

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          if (reccLogs) console.log('Recommendations response received');
          const newDiv = document.createElement('div');
          newDiv.innerHTML = text;

          const recommendations = newDiv.querySelector('section.row--recommendations');

          if (reccLogs) console.log('Recommendations extracted from response: ', recommendations);
          if (reccLogs) console.log('Recommendations HTML: ', recommendations.innerHTML);

          if (recommendations && recommendations.innerHTML.trim().length) {
            if (reccLogs) console.log('Injecting recommendations into the page');
            relatedSection.innerHTML = recommendations.innerHTML;
            document.dispatchEvent(new CustomEvent('recommendationsLoaded'));
            if (reccLogs) console.log('Recommendations loaded and event dispatched');
            intObs();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    const observer = new IntersectionObserver(handleIntersection);

    observer.observe(relatedSection);
  }

  if (document.querySelector('section.row--recommendations')) {
    related();
  }

  } catch(e) { console.error(e); }
})();
})();
